import { clamp } from '../controllerUiHelpers.js';

export const htmlEl = <K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className = '',
  text?: string
): HTMLElementTagNameMap[K] => {
  const node = document.createElement(tag);
  node.className = className;
  node.textContent = text ?? '';
  return node;
};

